
export class UserContextModel {
    userId?: string;
    softwareId?: string;
    accountId?: string;
    tokenVersion?: number;
    softwareCode?: string;
    apiGatewayUrl?: string;
    debtorId?: number;
    lAccountId?: number;
    iat?: number;
    exp?: number;
    isSuperUser?: boolean;
}

export class UserInfoModel {
    user?: Array<User>;
    account?: Account;
    property?: Property;
    accessControl?: AccessControl;
}

export interface User {
    ID?: string;
    email?: string;
    name?: string;
    department?: string;
}

export interface Account {
    accountId?: number;
    name?: string;
    settings?: AccountSetting;
}

export interface AccountSetting {
    isPaymentEnabled?: boolean;
    currencySymbol?: string;
    currencyCode?: string;
}

export interface Property {
    propertyId?: number;
    propertyNo?: string;
    propertyName?: string;
}

export interface AccessControl {
    isDailySales?: boolean;
}
